export default {
  signworkflows: (state) => state.signworkflows,
  searchParams: (state) => state.searchParams,
  pagination: (state) => state.pagination,
  signatoryFromDeskRhEmpCreation: (state) => state.signatoryFromDeskRhEmpCreation,
};
